export enum HelperFriendStatus {
    ENABLED = 'enabled',
    DISABLED = 'disabled',
    SHOW = 'show',
    USED = 'used',
}
